import React from "react"
import { navigate } from "gatsby"
import { globalHistory } from "@reach/router"
import { QueryParamProvider } from "use-query-params"

// use-query-params con la navegación de Gatsby. El `ReachAdapter` del tema cambia
// la dirección sin pasar por Gatsby, y en `gatsby develop` una ruta con `?q=` que
// Gatsby no cargó se muestra como su 404 de desarrollo (en producción no pasa).
const irA = replace => location =>
  navigate(globalHistory.location.pathname + (location.search || ""), {
    replace,
    state: location.state,
  })

const adapter = {
  replace: irA(true),
  push: irA(false),
  get location() {
    return globalHistory.location
  },
}

const GatsbyAdapter = ({ children }) => children(adapter)

export const wrapPageElementQueryParams = ({ element }) => (
  <QueryParamProvider adapter={GatsbyAdapter}>{element}</QueryParamProvider>
)
